export const OpenDayLink = () => (
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.96978 7.50467L14.1589 3.31552C15.3787 2.09573 17.3832 2.1226 18.6362 3.37553C19.8891 4.62844 19.916 6.63301 18.6962 7.85277L15.0592 11.4898"
      stroke="#262626"
      stroke-width="1.375"
      stroke-linecap="square"
    />
    <path
      d="M6.91839 10.543L3.28137 14.18C2.06157 15.3998 2.08847 17.4043 3.34137 18.6573C4.59432 19.9102 6.59884 19.9371 7.81865 18.7173L12.0078 14.5281"
      stroke="#262626"
      stroke-width="1.375"
      stroke-linecap="square"
    />
    <path
      d="M10.0312 11.9812C8.7783 10.7282 8.75145 8.72371 9.97121 7.50391"
      stroke="#262626"
      stroke-width="1.375"
      stroke-linecap="square"
    />
    <path
      d="M12.0112 9.99121C13.2641 11.2442 13.291 13.2487 12.0712 14.4684"
      stroke="#262626"
      stroke-width="1.375"
      stroke-linecap="square"
    />
  </svg>
);
